var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c('div',{staticClass:"badge",style:({
            'top': _vm.top+'px',
            'right': _vm.right+'px',
            'min-width': _vm.size+'px',
            'height': _vm.size+'px',
            'font-size': _vm.fontSize+'px',
            'line-height': _vm.fontSize+'px',
        })},[_vm._v(_vm._s(_vm.count))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }